import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import '@mdi/font/css/materialdesignicons.min.css'
import Toast from '@/components/global/Toast/index'
import { VLazyImagePlugin } from "v-lazy-image"
import qs from "qs"

Vue.config.productionTip = false
Vue.use(Toast)
Vue.use(VLazyImagePlugin)


Vue.prototype.$url = {
  getParams() {
    let q = window.location.search;
    if (!!q && q.length > 1) {
      q = q.substring(1);
      return qs.parse(q) || {};
    }
    return {};
  }
}
//-----------检测设备
Vue.prototype.$check = {
  cam() {
    return navigator.mediaDevices && navigator.mediaDevices.getUserMedia
  },
  async canVideo() {
    let status = false
    await navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        let arr = devices.filter(d => d.kind.toLowerCase() == 'videoinput')
        status = arr.length > 0
      }).catch(err => console.log(err))
    return status
  }
};

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.onError((error) => {
	const pattern = /Loading .*chunk.* failed/g;
	const isChunkLoadFailed = error.message.trim().match(pattern);
	console.log('=== router error ===')
	console.log(isChunkLoadFailed)
	const targetPath = router.history.pending.fullPath;
	if (isChunkLoadFailed) {
		console.log('=== reload router ===')
		router.replace(targetPath);
	}
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
